var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-container",
        { staticClass: "main_layer py-2", attrs: { fluid: "" } },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("p", { staticClass: "fs-40 fw-600 white-color mb-2" }, [
                      _vm._v("Произошла ошибка при аутентификации."),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-container",
        { staticClass: "py-4" },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "error" }, [
                  _c("p", { staticClass: "fs-22 fw-600 grey-color" }, [
                    _vm._v("Возможные причины ошибки:"),
                  ]),
                  _c("ul", { staticClass: "error-list" }, [
                    _c("li", { staticClass: "fs-18 grey-color fw-400 my-2" }, [
                      _vm._v(
                        '— У вас не установлено и не настроено программное обеспечение "КриптоПро CSP" версии 4.0 или выше'
                      ),
                    ]),
                    _c("li", { staticClass: "fs-18 grey-color fw-400 my-2" }, [
                      _vm._v(
                        "— Сертификат ключа проверки электронной подписи выдан Удостоверяющим центром Федерального казначейства."
                      ),
                    ]),
                    _c("li", { staticClass: "fs-18 grey-color fw-400 my-2" }, [
                      _vm._v("— Срок действия сертификата истек."),
                    ]),
                    _c("li", { staticClass: "fs-18 grey-color fw-400 my-2" }, [
                      _vm._v(
                        "— Сертификат ключа проверки электронной подписи находится в списке отозванных сертификатов."
                      ),
                    ]),
                    _c("li", { staticClass: "fs-18 grey-color fw-400 my-2" }, [
                      _vm._v('— Вы нажали "отмена" при выборе сертификата.'),
                    ]),
                  ]),
                  _c("p", { staticClass: "fs-22 fw-600 grey-color" }, [
                    _vm._v(
                      "Если в случае выполнения всех указанных условий ошибка повторяется, просьба обратиться в службу поддержки"
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }